<template>
  <ConfirmationModal
    :bodyText="bodyText"
    :cancelText="cancelText"
    :continueText="continueText"
    :headerText="modalHeader"
  >
    <div
      v-if="replyAttributes.length > 0"
    >
      <span :class="$style.mainText">
        The following Reply Attributes are associated
        with the {{ item.name }} user group. Attributes
        can be
        <a
          :href="groupUrl"
          rel="noopener noreferrer"
          target="_self"
          @click="linkClick"
        >
          edited in the user group
          <ArrowIcon
            :class="$style.arrowIcon"
          />
        </a>
      </span>
      <div :class="$style.labels">
        <span :class="$style.nameLabel">
          RADIUS Attribute Name
        </span>
        <span :class="$style.nameLabel">
          RADIUS Attribute Value
        </span>
      </div>
      <template
        v-for="(customAttribute, index) in replyAttributes"
      >
        <div
          :key="index"
          :class="$style.labels"
        >
          <InputOptionalValidation
            :key="customAttribute.name"
            :class="[$style.leftColumn, $style.attributeLabel]"
            :disabled="true"
            name="Property Name"
            :value="customAttribute.name"
          />
          <InputOptionalValidation
            :key="customAttribute.value"
            :class="$style.attributeLabel"
            :disabled="true"
            name="Property Value"
            :value="customAttribute.value"
          />
        </div>
      </template>
    </div>
    <span v-else>
      There are no Reply Attributes associated with
      the {{ item.name }} user group. Attributes can
      be
      <a
        :href="groupUrl"
        rel="noopener noreferrer"
        target="_self"
        @click="linkClick"
      > added in the user group
        <ArrowIcon
          :class="$style.arrowIcon"
        />
      </a>
    </span>
  </ConfirmationModal>
</template>

<script>
import { ItemTypeConsts, StoreModelMap } from 'client/util/Constants';
import { mapGetters } from 'vuex';
import ArrowIcon from 'public/img/icons/arrow-next.svg?inline';
import ConfirmationModal from 'client/components/Modal/ModalComponents/ConfirmationModal.vue';
import InputOptionalValidation from 'client/components/FormValidation/Input.vue';
import ModalEventBus from 'client/components/Modal/ModalEventBus';

const userGroupModel = StoreModelMap[ItemTypeConsts.userGroup];

export default {
  name: 'RadiusUserGroupsAttributesModal',

  components: {
    ArrowIcon,
    ConfirmationModal,
    InputOptionalValidation,
  },

  props: {
    item: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      bodyText: '',
      cancelText: '', // bodyText and cancelText empty strings to override default values
      continueText: 'done',
      groupData: {},
      modalHeader: 'RADIUS Reply Attributes',
    };
  },

  computed: {
    ...mapGetters(userGroupModel, [
      'getRadiusReplyAttributes',
    ]),

    groupUrl() {
      return `#/groups/user/${this.item.id}/details`;
    },

    replyAttributes() {
      return this.getRadiusReplyAttributes || [];
    },
  },

  methods: {
    linkClick() {
      ModalEventBus.close();
    },
  },
};
</script>

<style module>
@value ( jcGrey100, jcGrey200 ) from '~css/brand-colors.css';

.arrowIcon {
  height: 10px;
  width: 10px;
}

.arrowIcon path {
  fill: #337ab7; /* Same color used on the component ButtonLink.vue
  not available on brand-colors */
}

.mainText {
  display: block;
  margin-bottom: 25px;
}

.labels {
  align-items: stretch;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}

.nameLabel {
  flex: 1 0 50%;
  font-size: 12px;
  font-weight: 700;
  margin-left: 0.4rem;
}

.attributeLabel {
  height: 40px;
}

.attributeLabel input {
  background-color: jcGrey100;
  font-size: 14px;
}

.leftColumn {
  padding-right: 13px;
}
</style>
